import {autoserializeAs} from 'cerialize';

export abstract class ModelBase {
  public static readonly type: string;

  @autoserializeAs('type')
  public readonly type: string;
}
